import React from "react";
import { toJS } from "mobx";
import { inject, observer } from "mobx-react";
import { Spin, Button, message, Modal } from "antd";
import OtherDetailSet from "./otherDetailSet";
import WorkflowDetailSet from "./workflowDetailSet";
import {
  WeaTools,
  WeaTable,
  WeaLocaleProvider,
  WeaCheckbox,
  WeaDialog,
  WeaTop,
  WeaFormItem,
  WeaSelectGroup
} from "ecCom";
const getLabel = WeaLocaleProvider.getLabel;
const { getKey } = WeaTools;
const confirm = Modal.confirm;

@observer
class systemSetTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogtitle: ""
    };
  }

  changeDataSource = (e, item, type, column) => {
    const { tableStore } = this.props;
    const { dataSource } = tableStore;
    let newDataSource = [];
    let reverse = false;
    dataSource.map(data => {
      const isRow = type === "head" && data.key === item.key;
      data.subList &&
        data.subList.map(content => {
          if (isRow || content.key === item.key) {
            data.subList.some(item => {
              if (item["open"].value !== item["openRight"].value) {
                reverse = true;
              }
            });
          }
        });
    });
    newDataSource = dataSource.map(data => {
      const isRow = type === "head" && data.key === item.key;
      data.subList &&
        data.subList.map(content => {
          if (isRow || content.key === item.key) {
            if (column === "open" || content["open"].value === "1") {
              if (column === "openRight") {
                if (e === "1" && content[column].value === "1" && !reverse) {
                  content[column].value = "0";
                } else {
                  content[column].value = e;
                }
              } else {
                content[column].value = e;
              }
              if (e === "0") {
                content["openRight"].value = e;
              }
            } else {
              content[column].value = "0";
            }
          }
          return content;
        });
      if (isRow) {
        if (column === "open" || data["open"].value === "1") {
          if (column === "openRight") {
            if (e === "1" && data[column].value === "1" && !reverse) {
              data[column].value = "0";
            } else {
              data[column].value = e;
            }
          } else {
            data[column].value = e;
          }
          if (e === "0") {
            data["openRight"].value = e;
          }
        } else {
          data[column].value = "0";
        }
      }
      return data;
    });
    tableStore.changeDataSource(newDataSource);
  };

  chooseAllDataSource = (e, column) => {
    const { tableStore } = this.props;
    const { dataSource } = tableStore;
    let newDataSource = [];
    let reverse = false;
    dataSource.some(item => {
      if (item["open"].value !== item["openRight"].value) {
        reverse = true;
      }
      item.subList &&
        item.subList.map(content => {
          if (content["open"].value !== content["openRight"].value) {
            reverse = true;
          }
        });
    });
    newDataSource = dataSource.map(data => {
      if (column === "open" || data["open"].value === "1") {
        if (column === "openRight") {
          if (e === "1" && data[column].value === "1" && !reverse) {
            data[column].value = "0";
          } else {
            data[column].value = e;
          }
        } else {
          data[column].value = e;
        }
        if (e === "0") {
          data["openRight"].value = e;
        }
      } else {
        data[column].value = "0";
      }
      data.subList &&
        data.subList.map(content => {
          if (column === "open" || content["open"].value === "1") {
            if (column === "openRight") {
              if (e === "1" && content[column].value === "1" && !reverse) {
                content[column].value = "0";
              } else {
                content[column].value = e;
              }
            } else {
              content[column].value = e;
            }
            if (e === "0") {
              content["openRight"].value = e;
            }
          } else {
            content[column].value = "0";
          }
          return content;
        });
      return data;
    });
    if (column === "open") {
      tableStore.setOpenVal(e);
      tableStore.setRightDisabled(false);
      if (e === "0") {
        tableStore.setOpenRightVal(e);
        tableStore.setRightDisabled(true);
      }
    } else {
      tableStore.setOpenRightVal(e);
    }
    tableStore.changeDataSource(newDataSource);
  };

  detailConfig = item => {
    const { tableStore } = this.props;
    let dialogtitle = getLabel(19342, "详细设置") + "-";
    tableStore.setDialogtitle({
      dialogtitle: dialogtitle + item["otherParams"].groupname
    });
    if (item["otherParams"].detatilType === "2") {
      tableStore.getWorkflowCondition({
        module: item["otherParams"].groupcode
      });
    } else if (item["otherParams"].detatilType === "1") {
      tableStore.setTypeid(item["otherParams"].typeid);
      tableStore.getDetailCondition({
        id: item["otherParams"].id,
        typeid: item["otherParams"].typeid,
        module: item["otherParams"].groupcode
      });
    }
  };

  transformDataSource = () => {
    const { tableStore } = this.props;
    const { dataSource } = tableStore;
    let allOpen = "1";
    let allOpenRight = "1";
    if (JSON.parse(JSON.stringify(dataSource)).length > 0) {
      allOpen = JSON.parse(JSON.stringify(dataSource))[0]["open"].value;
      allOpenRight = JSON.parse(JSON.stringify(dataSource))[0]["openRight"]
        .value;
    }
    const renderCheckBox = (item, type, column, openVal) => {
      let disabled = false;
      if (column === "openRight" && openVal === "0") {
        disabled = true;
      }
      return (
        <div>
          <WeaCheckbox
            disabled={disabled}
            value={item[column].value}
            onChange={e => this.changeDataSource(e, item, type, column)}
          />
          {column === "open" &&
            item.details === "1" &&
            item[column].value === "1" && (
              <a
                onClick={e => {
                  this.detailConfig(item);
                }}
                style={{ marginLeft: 5, color: "#4d7ad8" }}
                href="javascript: void(0);"
              >
                {getLabel(19342, "详细设置")}
              </a>
            )}
        </div>
      );
    };
    const isAllSelect = (isOpen, val) => {
      if (isOpen === "0" && val === "0") return "0";
      else if (isOpen === "1" && val === "1") return "1";
      return "2";
    };

    const renderDataSource = JSON.parse(JSON.stringify(dataSource)).map(
      (group, groupIndex) => {
        let allSubOpen = "1";
        let allSubOpenRight = "1";
        if (groupIndex === 0) {
          allSubOpen = group["open"].value;
          allSubOpenRight = group["openRight"].value;
        }
        group.subList &&
          group.subList.map((item, index) => {
            let itemOpenVal = item["open"].value;
            let itemOpenRightVal = item["openRight"].value;
            if (index === 0) {
              allSubOpen = itemOpenVal;
              allSubOpenRight = itemOpenRightVal;
            }
            allSubOpen = isAllSelect(allSubOpen, itemOpenVal);
            allSubOpenRight = isAllSelect(allSubOpenRight, itemOpenRightVal);
            item.open = renderCheckBox(item, "item", "open");
            item.openRight = renderCheckBox(
              item,
              "item",
              "openRight",
              itemOpenVal
            );
            return;
          });
        // 处理自定义数据半选全选
        if (groupIndex !== 0 && !group.subList) {
          allSubOpen = group["open"].value;
          allSubOpenRight = group["openRight"].value;
        }
        let groupOpenVal = group["open"].value;
        let groupOpenRightVal = group["openRight"].value;
        if (group.subList) {
          groupOpenVal = allSubOpen;
          groupOpenRightVal = allSubOpenRight;
          group["open"].value = groupOpenVal;
          group["openRight"].value = groupOpenRightVal;
        }
        allOpen = isAllSelect(isAllSelect(allOpen, groupOpenVal), allSubOpen);
        allOpenRight = isAllSelect(
          isAllSelect(allOpenRight, groupOpenRightVal),
          allSubOpenRight
        );
        group.open = renderCheckBox(group, "head", "open");
        group.openRight = renderCheckBox(
          group,
          "head",
          "openRight",
          groupOpenVal
        );
        return group;
      }
    );
    let openVal = allOpen;
    tableStore.setOpenVal(openVal);
    let openRightVal = allOpen ? allOpenRight : "0";
    tableStore.setOpenRightVal(openRightVal);
    tableStore.setRightDisabled(allOpen === "0");
    return renderDataSource;
  };

  render() {
    const { tableStore, height } = this.props;
    const dataSource = this.transformDataSource();
    const {
      openVal,
      openRightVal,
      rightDisabled,
      otherDetailVisiable,
      condition
    } = tableStore;
    const columns = [
      {
        title: <div>{getLabel(388219, "提醒种类")}</div>,
        dataIndex: "title",
        key: "title",
        width: 288
      },
      {
        title: (
          <div style={{ marginLeft: -1 }}>
            <WeaCheckbox
              value={openVal}
              onChange={e => {
                this.chooseAllDataSource(e, "open");
              }}
            />
            <span style={{ paddingLeft: 5 }}>{getLabel(18095, "启用")}</span>
          </div>
        ),
        dataIndex: "open",
        key: "open",
        width: 216
      },
      {
        title: (
          <div style={{ marginLeft: -1 }}>
            <WeaCheckbox
              disabled={rightDisabled}
              value={openRightVal}
              onChange={e => {
                this.chooseAllDataSource(e, "openRight");
              }}
            />
            <span style={{ paddingLeft: 5 }}>
              {getLabel(388496, "启用右下角弹窗提醒")}
            </span>
          </div>
        ),
        dataIndex: "openRight",
        key: "openRight"
      }
    ];
    return (
      <div>
        <WeaTable
          columns={columns}
          dataSource={dataSource}
          childrenColumnName="subList"
          pagination={false}
          useFixedHeader={true}
          scroll={{ x: true, y: height }}
        />
        <OtherDetailSet systemSetStore={tableStore} />
        <WorkflowDetailSet systemSetStore={tableStore} />
      </div>
    );
  }
}

export default systemSetTable;



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/components/systemSetTable.js